import { useState, useCallback } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { getOrderRestrictions } from 'src/common/OrderRestrictions/api/orderRestrictionsApi';
import { OrderRestrictionsResponseUI } from 'src/types/OrderRestrictions';

export interface UseOrderRestrictionsReturn {
  isLoading: boolean;
  getOrderRestrictionsList: () => void;
  restrictions: OrderRestrictionsResponseUI | null;
  error?: Error | null;
}

export const useOrderRestrictions = (): UseOrderRestrictionsReturn => {
  const [restrictions, setRestrictions] =
    useState<OrderRestrictionsResponseUI>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const getOrderRestrictionsList = useCallback(async (): Promise<void> => {
    try {
      setIsLoading(true);
      const restrictionsData = await getOrderRestrictions();
      setRestrictions(restrictionsData);
    } catch (error) {
      setError(error);
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    error,
    restrictions,
    getOrderRestrictionsList,
    isLoading,
  };
};
